var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllOtherAssignmentImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 93,
    viewBox: "0 0 69 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H68.6733V93H4C1.79086 93 0 91.2091 0 89V4Z",
    fill: "#FAFCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3066 19.05H53.9881C54.5128 19.05 54.9381 19.4753 54.9381 20V73.5479C54.9381 74.0725 54.5128 74.4979 53.9881 74.4979H15.3066C14.782 74.4979 14.3566 74.0725 14.3566 73.5479V20C14.3566 19.4753 14.782 19.05 15.3066 19.05Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M42.5788 43.916H32.5276V46.2055H42.5788V43.916Z",
    fill: "#606060"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M48.4509 48.4668H32.5276V50.7563H48.4509V48.4668Z",
    fill: "#606060"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M42.5788 58.6387H32.5276V60.9282H42.5788V58.6387Z",
    fill: "#606060"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M48.4509 63.1914H32.5276V65.4809H48.4509V63.1914Z",
    fill: "#606060"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5619 27.916H19.4817V37.2983H28.5619V27.916Z",
    fill: "#E00B7E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5619 42.5527H19.4817V51.935H28.5619V42.5527Z",
    fill: "#E00B7E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5619 57.1914H19.4817V66.5737H28.5619V57.1914Z",
    fill: "#E00B7E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5369 32.5944L23.6074 34.2077L25.8268 31.2383",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5367 47.2094L23.6073 48.8227L25.8267 45.8496",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5369 61.9323L23.6074 63.5456L25.8268 60.5762",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M42.5788 28.9473H32.5276V31.2368H42.5788V28.9473Z",
    fill: "#606060"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M48.4509 33.498H32.5276V35.7876H48.4509V33.498Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllOtherAssignmentImg);
export default __webpack_public_path__ + "static/media/all-other-assignment-img.272fd7fed847604df59c7ae31655cf46.svg";
export { ForwardRef as ReactComponent };